import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import App from './App.vue';
import router from './router'
import { createPinia } from 'pinia';
//import { loadGlobalConfig } from './config';
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { errorHandler } from '@/utils/errorHandler'

const app = createApp(App);

const initApp = async () => {
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }
  app.use(ElementPlus, {
    locale: zhCn,  // 设置语言为中文
  })
  app.use(router)
  app.use(createPinia())

  // 配置文件加载，设置到全局
  //app.config.globalProperties.$config = await loadGlobalConfig()

  app.config.errorHandler = (err) => {
    console.error(err);
    errorHandler(err)
  }
  
  app.mount('#app')
}

initApp()